module.exports = __webpack_public_path__ + "img/planta_baixa_03.04e198f4.jpeg";